import { render, staticRenderFns } from "./MakingMoney.vue?vue&type=template&id=346edd80&scoped=true&"
import script from "./MakingMoney.vue?vue&type=script&lang=js&"
export * from "./MakingMoney.vue?vue&type=script&lang=js&"
import style0 from "./MakingMoney.vue?vue&type=style&index=0&id=346edd80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346edd80",
  null
  
)

export default component.exports